import i18next from 'i18next';
import { CarsConstatns } from '../../Components/Search/Constants';

import { getMarketCode } from '../market';

// Facet ids in the public API grammar → the legacy translation keys in I18n.ts
const TRANSLATION_KEY: Record<string, string> = {
  branchDisplayName: 'branch',
  colorName: 'color',
  segment: 'properties.segment',
  drivetrainType: 'drivingWheel',
  privateLease: 'leasingPrice',
};

export const defaultDisplaynameTranslation = (f: string) => {
  if (f === CarsConstatns.ODOMETER) {
    return i18next.t(getMarketCode() === 'NO' ? 'filter.odometerValueAsKm' : 'filter.mileage');
  }
  if (TRANSLATION_KEY[f]) return i18next.t(`filter.${TRANSLATION_KEY[f]}`);
  switch (f) {
    case CarsConstatns.MANUFACTURER:
    case CarsConstatns.MODEL_SERIES:
    case CarsConstatns.FUEL_TYPE:
    case CarsConstatns.GEARBOX_TYPE:
    case CarsConstatns.SEGMENT:
    case CarsConstatns.DRIVING_WHEEL:
    case CarsConstatns.ENVIRONMENT_CLASS:
    case CarsConstatns.COLOR:
    case CarsConstatns.PRICE:
    case CarsConstatns.LEASING_PRICE:
    case CarsConstatns.BRANCH:
    case CarsConstatns.MILEAGE:
    case CarsConstatns.MODEL_YEAR:
      return i18next.t(`filter.${f}`);
    default:
      return f;
  }
};
